module.exports = __webpack_public_path__ + "static/media/footer3.14496b69.jpeg";